<template>
    <div class="wrapper-transactions-list">
        <div class="card">
            <div class="card-header">
                <div>Transaction List</div>
            </div>
            <div class="card-body">
                <div class="siot-table-wrapper">
                    <div class="siot-table-header">
                        <div class="siot-table-header-left">
                            <div class="siot-table-search">
                                <div class="siot-table-search-field">
                                    <input type="text" id="transactionsSearch" v-model="filter" v-on:keyup="searchKeyUp" v-on:keydown="searchKeyDown" placeholder="Search" />
                                </div>
                            </div>

                            <div class="siot-table-filter">
                                <button class="btn btn-primary mobile-sort-btn" @click="shwoHideSort()"><i class="fa fa-sort" aria-hidden="true"></i>Sort</button>
                            </div>
                        </div>

                        <div class="siot-table-header-right">
                            <div class="siot-table-export">
                                <button class="btn btn-primary export-btn" id="transactionsExportButton" @click="showfileFormatPopup()">Export</button>
                            </div>

                            <div class="siot-table-size">
                                <label for="size-page">Display:</label>
                                <select id="size-page" v-model="sortSettings.size" @change="getTransactionList(true)" class="form-control custom-select">
                                    <option value="40" selected>40</option>
                                    <option value="60">60</option>
                                    <option value="80">80</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="siot-table-content">
                        <div v-if="mobileVisible == true && transactionList" class="list-mobile">
                            <div v-for="(item, index) in transactionList"  v-on:click="clickOnRow(item.transactionId)" :data-iccid="item.transactionId" v-bind:key="index" class="item-mobile">
                                <div class="item-header-mobile">
                                    <div class="icon">
                                        <img v-if="item.carrierName == 'SimonIoT'" src="../assets/img/carrier-simon.svg"/>
                                        <img v-else-if="item.carrierName == 'T-Mobile'" src="../assets/img/carrier-tmobile.svg"/>
                                        <img v-else-if="item.carrierName == 'Vodafone'" src="../assets/img/carrier-vodafone.svg"/>
                                        <img v-else src="../assets/img/carrier-simon.svg"/>
                                    </div>
                                    <div class="info-wrapper-mobile">
                                        <strong class="transaction-id">{{item.transactionId}}</strong>
                                        <strong class="transaction-status">{{item.transactionStatus}}</strong>
                                    </div>
                                </div>
                                <div class="data-table-mobile">
                                    <div class="row-mobile msisdn-mobile">
                                        <div class="icon-mobile">
                                            <img src="../assets/img/mobile-icons/mobile-icon2.svg" alt="">
                                        </div>
                                        <div class="info">
                                            <span class="value">{{item.requestType}}</span>
                                        </div>
                                    </div>
                                    <div class="row-mobile msisdn-mobile">
                                        <div class="icon-mobile">
                                            <img src="../assets/img/mobile-icons/mobile-icon6.svg" alt="">
                                        </div>
                                        <div class="info">
                                            <span class="value">{{item.email}}</span>
                                        </div>
                                    </div>
                                    <div class="row-mobile msisdn-mobile">
                                        <div class="icon-mobile">
                                            <img src="../assets/img/mobile-icons/mobile-icon1.svg" alt="">
                                        </div>
                                        <div class="info">
                                            <span class="value">{{item.addedOn}}</span>
                                        </div>
                                    </div>
                                    <div class="row-mobile msisdn-mobile">
                                        <div class="icon-mobile">
                                            <img src="../assets/img/mobile-icons/mobile-icon17.svg" alt="">
                                        </div>
                                        <div class="info">
                                            <span class="value">{{item.noOfSims}}</span>
                                        </div>
                                    </div>
                                    <div class="row-mobile msisdn-mobile">
                                        <div class="icon-mobile">
                                            <img src="../assets/img/mobile-icons/mobile-icon7.svg" alt="">
                                        </div>
                                        <div class="info">
                                            <span class="value">{{item.completedOn}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="siot-table table-transactions-list">
                            <table  v-if='transactionList' class="table b-table table-striped table-hover b-table-selectable b-table-select-multi">
                                <thead role="rowgroup">
                                    <tr role="row">
                                        <th v-on:click="changeSort(1)" :aria-sort="setAreaSort(1)">Transaction ID</th>
                                        <th v-on:click="changeSort(2)" :aria-sort="setAreaSort(2)">Request Type</th>
                                        <th v-on:click="changeSort(8)" :aria-sort="setAreaSort(8)">Carrier</th>
                                        <th v-on:click="changeSort(3)" :aria-sort="setAreaSort(3)">Email</th>
                                        <th v-on:click="changeSort(4)" :aria-sort="setAreaSort(4)">Added On</th>
                                        <th v-on:click="changeSort(5)" :aria-sort="setAreaSort(5)">No Of Sims</th>
                                        <th v-on:click="changeSort(6)" :aria-sort="setAreaSort(6)">Completed On</th>
                                        <th v-on:click="changeSort(7)" :aria-sort="setAreaSort(7)">Transaction Status</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="(item, index) in transactionList" :data-iccid="item.transactionId" v-bind:key="index">
                                        <td v-on:click="clickOnRow(item.transactionId)">{{item.transactionId}}</td>
                                        <td v-on:click="clickOnRow(item.transactionId)">{{item.requestType}}</td>
                                        <td v-on:click="clickOnRow(item.transactionId)">{{item.carrierName}}</td>
                                        <td v-on:click="clickOnRow(item.transactionId)">{{item.email}}</td>
                                        <td v-on:click="clickOnRow(item.transactionId)">{{item.addedOn}}</td>
                                        <td v-on:click="clickOnRow(item.transactionId)">{{item.noOfSims}}</td>
                                        <td v-on:click="clickOnRow(item.transactionId)">{{item.completedOn}}</td>
                                        <td v-on:click="clickOnRow(item.transactionId)">{{item.transactionStatus}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="loader-sim-list" v-if="loadingLogs == true && noLogs == false && noLoading == false">
                            <div class="sk-wave">
                                <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                            </div>
                        </div>

                        <div class="no-sims" v-if="noLogs == true && loadingLogs == false">
                            <h2 class="text">You have no Transaction</h2>
                        </div>
                    </div>

                    <div class="siot-table-footer">
                        <div class="siot-table-footer-center">
                            <nav v-if="paginationCount" aria-label="Page navigation example">
                                <paginate :page-count="paginationCount" v-model="sortSettings.page" :click-handler="paginationControll" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"></paginate>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal size="md" ref="fileFormatModal" id="fileFormatModal" centered hide-footer>
            <div class="file-format-popup">
                <img src="../assets/img/file-format.svg">
                <h3>Save export file as:</h3>
                <div>
                    <button class="btn btn-primary csv" v-on:click="exportCsv">CSV</button>
                    <button class="btn btn-primary xls" v-on:click="exportXlsx">XLSX</button>
                </div>
                <button class="btn btn-light" @click="hidefileFormatPopup()">Cancel</button>
            </div>
        </b-modal>
        <FTSSort v-if="mobileSort.visible" :settingsSort="sortingSettings" :directionSort="sortSettings.desc" :columnSort="sortSettings.sort" v-on:hideSort="shwoHideSort" v-on:submitSort="submitSort"></FTSSort>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Axios from 'axios';
    import globalStore from '../variables';
    import Paginate from 'vuejs-paginate';
    import FTSSort from "../ftsComponents/FTSSort";

    export default {
        name: 'Transaction',
        components: {
            Paginate: Paginate,
            FTSSort
        },
        data() {
            return {
                sortingSettings: [
                    {
                        label: 'Transaction ID',
                        column: 1
                    },
                    {
                        label: 'Request Type',
                        column: 2
                    },
                    {
                        label: 'Carrier',
                        column: 8
                    },
                    {
                        label: 'Email',
                        column: 3
                    },
                    {
                        label: 'Added On',
                        column: 4
                    },
                    {
                        label: 'No of Sims',
                        column: 5
                    },
                    {
                        label: 'Completed On',
                        column: 6
                    },
                    {
                        label: 'Transaction Status',
                        column: 7
                    },
                ],
                mobileSort: {
                    column: 0,
                    direction: 0,
                    visible: false
                },
                mobileVisible: false,
                checkStatusTransaction: 0,
                loadingLogs: true,
                noLogs: false,
                noLoading: false,
                filter: '',
                paginationCount: 0,
                searchString: '',
                sortSettings: {
                    page: 1,
                    size: 40,
                    sort: 1,
                    desc: true
                },
                transactionList: [],
                tableFields: {
                    transactionId: {
                        label: 'ID',
                        sortable: true
                    },
                    requestType: {
                        label: 'Type',
                        sortable: true
                    },
                    transactionStatus: {
                        label: 'Status',
                        sortable: true
                    },
                    email: {
                        label: 'User',
                        sortable: true
                    },
                    noOfSims: {
                        label: 'Number of SIMs',
                        sortable: true
                    },
                    addedOn: {
                        label: 'Transaction start',
                        sortable: true
                    },
                    completedOn: {
                        label: 'Transaction completed',
                        sortable: true
                    }
                },
                typingTimer: '',
                interval: '',
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                if (from.name == 'TransactionDetails') {
                    vm.sortSettings = vm.$session.get('transactionsSortSettings');
                    vm.filter = vm.$session.get('filter');
                    vm.searchString = vm.$session.get('searchString') ? vm.$session.get('searchString') : '';
                    vm.paginationCount = vm.$session.get('paginationCount')
                    if (Boolean(vm.sortSettings)) {
                        vm.$session.remove('transactionsSortSettings')
                    } else {
                        vm.sortSettings = {
                            page: 1,
                            size: 40,
                            sort: 1,
                            desc: true
                        }
                    }
                    vm.getTransactionList(false)
                } else {
                    if (vm.$session.get('transactionsSortSettings')){
                        vm.$session.remove('transactionsSortSettings')
                    }
                    if (vm.$session.get('paginationCount')){
                        vm.$session.remove('paginationCount')
                    }
                    if (vm.$session.get('filter')){
                        vm.$session.remove('filter')
                    }
                    if (vm.$session.get('searchString')){
                        vm.$session.remove('searchString')
                    }
                    vm.getTransactionList(true)
                }
            })
        },
        mounted() {
            if (window.ftsTransactionID != '' && window.ftsTransactionID != undefined) {
                this.showResultActiveSims();
            }
            this.showMobileElements();
        },
        methods: {
            submitSort(value) {
                this.sortSettings.sort = value.column;
                this.sortSettings.desc = value.direction;
                this.getTransactionList(true);
            },
            shwoHideSort() {
                this.mobileSort.visible = (this.mobileSort.visible == true) ? false : true;
            },
            showMobileElements() {
                const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

                if (width < 992) {
                    this.mobileVisible = true;
                } else {
                    this.mobileVisible = false;
                }
            },
            searchKeyUp() {
                clearTimeout(this.typingTimer)
                this.typingTimer = setTimeout(() => {
                    this.searchRow()
                }, 500)
            },
            searchKeyDown() {
                clearTimeout(this.typingTimer)
            },
            searchRow() {
                if (this.filter.length > 0) {
                    this.searchString = '&search=' + this.filter;
                } else {
                    this.searchString = ''
                }
                this.getTransactionList(true)
            },
            clickOnRow(transactionID) {
                this.$session.set('transactionsSortSettings', this.sortSettings)
                this.$session.set('paginationCount', this.paginationCount)
                this.$session.set('filter', this.filter)
                this.$session.set('searchString', this.searchString)
                this.$router.push('/transaction/' + transactionID);
            },
            changeSort(sortId) {
                this.loadingLogs = true;
                if (sortId == this.sortSettings.sort) {
                    this.sortSettings.desc = !this.sortSettings.desc
                }
                this.sortSettings.sort = sortId
                this.getTransactionList(false)
            },
            setAreaSort(sortId) {
                if (sortId != this.sortSettings.sort) {
                    return 'none'
                } else if (sortId == this.sortSettings.sort && this.sortSettings.desc) {
                    return 'descending'
                } else if (sortId == this.sortSettings.sort && this.sortSettings.desc == false) {
                    return 'ascending'
                }
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },
            getPagination() {
                Axios.get(globalStore.data.restApiUrl + "/transactions-new/page-count?size=" + this.sortSettings.size + this.searchString)
                    .then(response => {
                        if (response.status == 200) {
                            this.paginationCount = Number (response.data);
                        } else {
                            this.$notify({
                                type: 'warn',
                                group: 'notification',
                                title: 'Getting data error',
                                text: 'Something was wrong in getting data from database. Please contact with support.',
                                duration: 5000,
                            });

                            return false;
                        }
                    }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Something was wrong in getting data from database. Please contact with support.',
                        duration: 5000,
                    });
                    console.log(error)

                    return false;
                })
            },
            getTransactionList(notPagination) {
                if (notPagination){
                    this.sortSettings.page = 1;
                    this.getPagination();
                }
                this.checkStatusTransaction = 0;
                this.loadingLogs = true;
                Axios.get(globalStore.data.restApiUrl + '/transactions-new/all' + '?page=' + this.sortSettings.page + '&size=' + this.sortSettings.size + '&sort=' + this.sortSettings.sort + '&desc=' + this.sortSettings.desc + this.searchString)
                    .then(response => {
                        this.transactionList = response.data.response;

                        if (!this.transactionList) {
                            this.loadingLogs = false;
                            this.noLogs = true;
                        } else {
                            this.loadingLogs = false;
                            this.noLogs = false;

                            for (let item of this.transactionList) {

                                if (item.transactionStatus == "In Progress" || item.transactionStatus == "Submitted") {
                                    this.checkStatusTransaction++
                                }

                                if (item.addedOn == null) {
                                    item.addedOn = '-'
                                }

                                if (item.completedOn == null) {
                                    item.completedOn = '-'
                                }
                            }
                            if (this.checkStatusTransaction > 0) {
                                this.noLoading = true
                                this.checkInterval();
                            } else {
                                this.noLoading = false
                            }
                        }

                    }).catch(error => {
                        console.log(error)
                    })
            },
            checkInterval() {
                if (this.checkStatusTransaction > 0 && this.$router.currentRoute.name == 'Transaction Logs') {
                    clearTimeout(this.interval);
                    this.interval = setTimeout(() => {
                        this.getTransactionList(false);
                    }, 5000)
                }
            },
            paginationControll(ev) {
                this.loadingLogs = true;
                this.sortSettings.page = ev;
                this.getTransactionList(false);
            },
            searchRow: function () {
                this.loadingLogs = true;
                if (this.filter.length > 2) {
                    this.searchString = '&search=' + escape(this.filter);
                } else {
                    this.searchString = '';
                }
                this.getTransactionList(true)
            },
            showResultActiveSims() {
                this.$notify({
                    type: 'success',
                    group: 'notification',
                    title: 'Transaction number ' + window.ftsTransactionID + ' done',
                    text: 'If you want to see details of the transaction: <a href="/?#/transaction/' + window.ftsTransactionID + '">Click here</a>',
                    duration: 5000,
                });
                setTimeout(() => {
                    window.ftsTransactionID = ''
                }, 3000)
            },
            setTimeToLocal (data) {
                let dateHistoryTime = new Date(data.getTime());

                if (dateHistoryTime.getHours() > 12) {
                    let tempHour = (dateHistoryTime.getHours() + 24) % 12 || 12;
                    if (dateHistoryTime.getMinutes() == 59) {
                        var hoursHistory = tempHour + ':' + ("0" + dateHistoryTime.getMinutes()).slice(-2) + ' PM'
                    } else {
                        var hoursHistory = tempHour + ':' + ("0" + (dateHistoryTime.getMinutes() + 1)).slice(-2) + ' PM'
                    }
                } else {
                    if (dateHistoryTime.getHours() == 0) {
                        var hoursHistory = '12' + ':' + ("0" + (dateHistoryTime.getMinutes() + 1)).slice(-2) + ' AM'
                    } else {
                        var hoursHistory = dateHistoryTime.getHours() + ':' + ("0" + (dateHistoryTime.getMinutes() + 1)).slice(-2) + ' AM'
                    }
                }

                let finalDate = data.getMonth() + 1 + '/' + data.getDate() + '/' + data.getFullYear() + ' ' + hoursHistory;
                return finalDate;
            },
            showfileFormatPopup() {
                this.$refs['fileFormatModal'].show()
            },
            hidefileFormatPopup() {
                this.$refs['fileFormatModal'].hide()
            },
            exportCsv() {
                this.$refs['fileFormatModal'].hide()

                Axios.get(`${globalStore.data.restApiUrl}/transactions-new/all/csv?sort=${this.sortSettings.sort}&desc=${this.sortSettings.desc}${this.searchString}`)
                    .then(response => {
                        let csvContent = "data:text/csv;charset=utf-8," + response.data;
                        var fileLink = document.createElement('a');fileLink.href = csvContent;
                        fileLink.setAttribute('download', 'transactions_export.csv');
                        document.body.appendChild(fileLink);
                        fileLink.click();
                    }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'SIMs export went wrong',
                        text: 'Something went wrong during SIMs export. Please contact with support.',
                        duration: 3000,
                    });
                    console.log(error);
                });
            },
            exportXlsx() {
                this.$refs['fileFormatModal'].hide()

                Axios.get(globalStore.data.restApiUrl + "/transactions-new/all/xlsx" + '?sort=' + this.sortSettings.sort + '&desc=' + this.sortSettings.desc + this.searchString, {responseType: 'blob'})
                    .then((response) => {
                        const fileLink = URL.createObjectURL(new Blob([response.data],
                            {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                            )
                        );
                        const link = document.createElement('a')
                        link.href = fileLink
                        link.setAttribute('download', 'transactions_export.xlsx')
                        document.body.appendChild(link)
                        link.click()
                    }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'SIMs export went wrong',
                        text: 'Something went wrong during SIMs export. Please contact with support.',
                        duration: 3000,
                    });
                    console.log(error);
                });
            }
        },
        beforeDestroy() {
            this.checkStatusTransaction = 0;
            clearTimeout(this.interval)
        }
    }
</script>

<style src="spinkit/scss/spinkit.scss" lang="scss" />
<style lang="scss" scoped>
    .wrapper-transactions-list {
        .card {
            .card-body {
                padding: 20px 0;
            }
        }
    }

    #fileFormatModal___BV_modal_body_ {
        padding-top: 0;
        .file-format-popup {
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: #fff;
            padding: 0 20px 20px;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;

            h3 {
                font-size: 15px;
                margin-top: 8px;
                margin-bottom: 20px;
            }

            .btn {
                width: 100px;
            }

            .btn-primary {
                margin: 0 10px 20px;
            }

            .btn-light {
                margin: 10px 0 0;
            }

            .csv {
                background-color: #00559F;
                border-color: #00559F;
            }
            .xls {
                background-color: #207245;
                border-color: #207245;
            }

            .close-icon {
                position: absolute;
                top: 20px;
                right: 20px;
                cursor: pointer;
            }
        }
    }

    table {
        @media (min-width: 1200px) and (max-width: 1600px) {
            font-size: 0.75em;
        }
        tbody {
            tr {
                cursor: pointer;
            }
        }
        tr {
            a {
                i {
                    &::before {
                        color: #000;
                    }
                }
            }
        }
    }

    .pagination {
        margin-top: 5px;
    }

.dark-theme {

    .table {
        color: #EDEEEF;

        thead {
            tr {
                th {
                    border-color: #1A1C1D;
                }
            }
        }

        tbody {
            tr {
                &:nth-of-type(odd) td {
                    background-color: #2F353A;
                }
                &:nth-of-type(even) td {
                    background-color: #3A4149;
                }

                td {
                    border-color: #1A1C1D;
                    .btn-secondary {
                        .fa-pencil {
                            color: #EDEEEF;
                        }
                    }
                }

                &[aria-selected="false"] {
                    .fts-checkbox-table {
                        border-color: #EDEEEF;
                    }
                }

                &:hover td{
                    background-color: #0088FF;
                }
            }
        }
    }

    #fileFormatModal___BV_modal_content_ {
        background-color: #3a4149;
        color: #EDEEEF;

        button {
            color: #fff;
        }
        .file-format-popup {
            background-color: #3a4149;
            color: #EDEEEF;
        }

        .modal-body {
            button.btn-light {
                color: #23282c;
            }
        }
    }
}

.transactions-list-mobile {
background-color: #E4E5E6;
    padding: 20px 8px;

    .transaction-mobile {
        margin-bottom: 20px;
        background-color: #FFFFFF;
        border-radius: 10px;
        box-shadow: 0px 3px 6px #00000029;

        .transaction-header {
            padding: 14px 10px;
            display: flex;
            justify-content: flex-start;

            .image {
                margin-right: 10px;

                img {
                    max-width: 16px;
                }
            }

            .info {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-weight: 700;
                color: #2F353A;
                font-size: 14px;
            }
        }

        .data-table-mobile {
            padding: 7px 0;
            border: 1px solid #E5E5E5;
            border-radius: 10px;
            background-color: #F6F6F6;

            .row-mobile {
                padding: 0 9px;
                display: flex;
                align-items: center;

                i {
                    font-size: 16px;
                    width: 16px;
                    margin-right: 9px;
                    text-align: center;
                }

                .info {
                    width: 100%;
                }
                span {
                    display: block;
                    padding: 7px 0;
                    border-bottom: 1px solid #EEEEEE;

                    &.label {
                        display: inline-block;
                        width: 150px;
                    }
                }

                &:last-child {
                    span {
                        border-bottom: none;
                    }
                }
            }
        }
    }
}


.filter-wrapper {
    display: flex;

    button {
        margin-left: 20px;
    }
}
</style>
